import { Field, reduxForm, SubmissionError } from "redux-form";
import { Button, Input } from "expano-components";

import { Main, Dashboard } from "components";
import useCreate from "hooks/useCreate";

import { ReactComponent as ShopIcon } from "icons/shop.svg";

const InputField = (props) => <Input {...props} />;

const CurrencyNew = ({ handleSubmit, pristine, invalid, history }) => {
  const { is_creating, create } = useCreate({
    path: "/currencies",
    onSuccess: ({ id }) => {
      history.push(`/currencies/${id}`);
    },
    onError: (err) => {
      throw new SubmissionError(err);
    },
  });

  const onSubmit = (values) => create(values);

  return (
    <Main
      page={{
        name: "Waluty",
        icon: <ShopIcon />,
        breadcrumbs: [
          {
            name: "Waluty",
            path: "/currencies",
          },
          { name: "Dodaj walutę" },
        ],
      }}
    >
      <div className="dashboard-wrapper-flex">
        <div className="column-half">
          <Dashboard
            footer={
              <>
                <Button
                  type="cancel"
                  onClick={() => history.push("/currencies")}
                />
                <Button
                  type="save"
                  text="Utwórz"
                  disabled={pristine || is_creating || invalid}
                  onClick={handleSubmit(onSubmit)}
                />
              </>
            }
          >
            <form
              className="dashboard__form"
              onSubmit={handleSubmit(onSubmit)}
              noValidate
            >
              <div className="row m-b-10">
                <div className="box-6">
                  <Field
                    name="name"
                    label="Nazwa"
                    component={InputField}
                    type="text"
                  />
                </div>
                <div className="box-6">
                  <Field
                    name="identifier"
                    label="Identyfikator"
                    component={InputField}
                    type="text"
                  />
                </div>
              </div>
              <div className="row">
                <div className="box-6">
                  <Field
                    name="default_suggested_price_exchange_rate"
                    label="Domyślny kurs w sugerowaniu ceny"
                    component={InputField}
                    type="number"
                    step="0.0001"
                  />
                </div>
              </div>
            </form>
          </Dashboard>
        </div>
      </div>
    </Main>
  );
};

const validate = (values) => {
  const errors = {};

  if (!values.name) {
    errors.name = "Pole wymagane!";
  }

  if (!values.identifier) {
    errors.identifier = "Pole wymagane!";
  } else if (!/^[A-Z]{3}$/.test(values.identifier)) {
    errors.identifier = "Identyfikator musi składać się z 3 wielkich liter";
  }

  if (
    values.default_suggested_price_exchange_rate === undefined ||
    values.default_suggested_price_exchange_rate === null ||
    values.default_suggested_price_exchange_rate === ""
  ) {
    errors.default_suggested_price_exchange_rate = "Pole wymagane!";
  } else if (Number(values.default_suggested_price_exchange_rate) <= 0) {
    errors.default_suggested_price_exchange_rate =
      "Kurs musi być większy od 0";
  }

  return errors;
};

export default reduxForm({
  form: "create-currency",
  enableReinitialize: true,
  validate,
})(CurrencyNew);
